import Api from 'utils/api'

// removed limit !!
export const fetchDepartments = ({ offset, ordering, search }) =>
  Api.get(['departments'], { offset, ordering, search })

export const fetchDepartment = ({ id }) => Api.get(['departments', id])
